module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAH1JREFUWEftl8sNgDAMQ91RmCELwCZsxiiwgHdgE5B64heEVEURkntu7dfXS1qQvEpyPwRwM2BmM4A+6GlWkt0x+wlgCyqvsSRPnS7AdWMrlJnViwlABmRABmRABmRABmTgPwZaZ0Dv/BcDE4AxCGAhObyO5UHFbqy+ZukGdq0nsiG8VwzIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_maximize_n.png
// module id = 77vm
// module chunks = 96